import { useMemo } from "react";

type NullifiedArray<T> = (T | null | undefined)[] | null | undefined;

export const unnulifyArray = <T>(array: NullifiedArray<T>): NonNullable<T>[] => {
  if (!Array.isArray(array)) {
    return [];
  }

  const result = array.filter(
    (el): el is NonNullable<T> => el !== undefined && el !== null,
  );

  return result;
};

export const useUnnulifyArray = <T>(
  array: NullifiedArray<T>,
): { unnulifiedArray: NonNullable<T>[] } => {
  const unnulifiedArray = useMemo(() => unnulifyArray<T>(array), [array]);

  return { unnulifiedArray };
};
